import React from 'react';
import { ModalForm } from '@components/modal';
import { IModalConfigureSocialBenefits } from '../models/ModalConfigureSocialBenefits';
import { Options } from '../models/ModalInformationImportant';
import './ModalConfigureSocialBenefits.scss';
import { Formik, Form } from 'formik';
import { SelectInput } from '@components/input';
import { formatOptions } from '@utils/Options';
import { ButtonIcon, Button } from '@components/button';

export const ModalConfigureSocialBenefits: React.FC<IModalConfigureSocialBenefits> = ({
    isOpen,
    socialBenefitsConfigurationValues,
    handleBack,
    mainAction,
    shouldDisbaleSocialBenefitButtons,
}) => {
    return (
        <ModalForm title={<p>Importante</p>} isOpen={isOpen} closeIcon={false} className="modal-configure-social-benefits">
            <div className="modal-configure-social-benefits-container">
                <p>Selecciona cómo prefieres realizar la transmisión de información a Nómina electrónica</p>
                <Formik
                    initialValues={{
                        service_bonus:
                            socialBenefitsConfigurationValues.service_bonus == Options.EFFECTIVE_PAYMENT.toLocaleLowerCase()
                                ? Options.EFFECTIVE_PAYMENT
                                : Options.MONTHLY,
                        severance:
                            socialBenefitsConfigurationValues.severance == Options.EFFECTIVE_PAYMENT.toLocaleLowerCase()
                                ? Options.EFFECTIVE_PAYMENT
                                : Options.MONTHLY,
                        electronic_payroll_vacation_periodicity:
                            socialBenefitsConfigurationValues.electronic_payroll_vacation_periodicity ==
                            Options.EFFECTIVE_PAYMENT.toLocaleLowerCase()
                                ? Options.EFFECTIVE_PAYMENT
                                : Options.MONTHLY,
                    }}
                    onSubmit={(values): void => {
                        mainAction(values.service_bonus, values.severance, values.electronic_payroll_vacation_periodicity);
                    }}
                >
                    <Form>
                        <table className="social__benefits_table">
                            <tbody>
                                <tr>
                                    <th>
                                        <strong>Prima de servicios:</strong>
                                    </th>
                                    <td className="selectInput">
                                        <SelectInput
                                            disabled={shouldDisbaleSocialBenefitButtons}
                                            name="service_bonus"
                                            options={formatOptions([
                                                { id: Options.MONTHLY, name: 'Provisión mensual' },
                                                { id: Options.EFFECTIVE_PAYMENT, name: 'Fecha efectiva de pago' },
                                            ])}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <strong>Cesantías/Intereses sobre cesantías:</strong>
                                    </th>
                                    <td className="selectInput">
                                        <SelectInput
                                            disabled={shouldDisbaleSocialBenefitButtons}
                                            name="severance"
                                            options={formatOptions([
                                                { id: Options.MONTHLY, name: 'Provisión mensual' },
                                                { id: Options.EFFECTIVE_PAYMENT, name: 'Fecha efectiva de pago (Diciembre)' },
                                            ])}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <strong>Vacaciones</strong>
                                    </th>
                                    <td className="selectInput">
                                        <SelectInput
                                            name="electronic_payroll_vacation_periodicity"
                                            options={formatOptions([
                                                { id: Options.MONTHLY, name: 'Provisión mensual' },
                                                { id: Options.EFFECTIVE_PAYMENT, name: 'Fecha efectiva de pago' },
                                            ])}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="social__benefits__button-container">
                            <ButtonIcon
                                onClick={handleBack}
                                type="button"
                                iconName="backArrowWhite"
                                color="green"
                                className="modal-payment-plan__container-modal"
                            >
                                Volver
                            </ButtonIcon>
                            <Button color="green-light-3" type="submit">
                                Confirmar
                            </Button>
                        </div>
                    </Form>
                </Formik>
            </div>
        </ModalForm>
    );
};
